import { render, staticRenderFns } from "./CertificateLists.vue?vue&type=template&id=647a2027&scoped=true&"
import script from "./CertificateLists.vue?vue&type=script&lang=js&"
export * from "./CertificateLists.vue?vue&type=script&lang=js&"
import style0 from "./CertificateLists.vue?vue&type=style&index=0&id=647a2027&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647a2027",
  null
  
)

export default component.exports